import styled from 'styled-components';

export const ValRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px 18px;
`;

export const ValChip = styled.button<{ $selected: boolean }>`
  cursor: pointer;
  font-family: var(--hand);
  font-size: 19px;
  font-weight: 600;
  color: ${({ $selected }) => ($selected ? '#fff' : 'rgba(255,255,255,.4)')};
  padding: 2px 1px 3px;
  background: none;
  border: none;
  border-bottom: 2px solid
    ${({ $selected }) => ($selected ? 'rgba(255,255,255,.85)' : 'transparent')};
  text-shadow: 0 0 7px rgba(255, 255, 255, 0.1);
  transition:
    color 0.15s,
    border-color 0.15s;

  &:hover {
    color: rgba(255, 255, 255, 0.72);
  }
`;
